module.exports = __webpack_public_path__ + "img/detailDataList.0b5dad3d.png";